import React, { ChangeEvent, useState } from 'react'
import { CreateBalanceOperationForm } from '../../widgets/CreateBalanceOperationForm'
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormSelect,
  CRow,
} from '@coreui/react-pro'
import { CreateDepositHeadwayForm } from '../../widgets/CreateDepositHeadwayForm'
import { CreateDeposits } from '../../widgets/CreateDeposits'

const TYPE_OPTIONS = [
  {
    label: 'Balance operation',
    value: 'BALANCE',
  },
  {
    label: 'Deposit',
    value: 'DEPOSIT',
  },
]

export const CreateBalanceOperation = () => {
  const [type, setType] = useState('')

  const handleChange = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    let value

    value = event.currentTarget.value

    setType(value)
  }

  return (
    <div>
      <CCard className="mb-4">
        <CCardHeader className="d-sm-flex justify-content-between align-items-center">
          <strong>Create operation</strong>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol sm={4}>
              <CFormSelect
                id="type"
                name="type"
                value={type}
                onChange={handleChange}
                label="Operation type"
                required
              >
                <option value="">Choose operation type</option>
                {TYPE_OPTIONS.map((item) => (
                  <option value={item.value} key={item.value}>
                    {item.label}
                  </option>
                ))}
              </CFormSelect>
            </CCol>
          </CRow>
          {type === 'BALANCE' && <CreateBalanceOperationForm />}
          {type === 'DEPOSIT' && <CreateDeposits />}
        </CCardBody>
      </CCard>
    </div>
  )
}
